"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { IconExternalLink as IconExternalLink$1 } from '@tabler/icons-react';
import '../../Icon.mjs';
import IconView from '../../../../views/IconView.mjs';

const IconExternalLink = (props) => {
  return /* @__PURE__ */ jsx(IconView, { ...props, children: /* @__PURE__ */ jsx(IconExternalLink$1, {}) });
};

export { IconExternalLink, IconExternalLink as default };
//# sourceMappingURL=IconExternalLink.mjs.map
